<template>
  <div>
    <div class="title">
      <span>发表专利</span>
    </div>
    <div class="list">
        <div class="item" v-for="(item,index) in patentList" :key="index">
          <div class="left">
            <h3>{{ item.title}}</h3>
            <p>专利类型: {{ item.patentTypeName}}</p>
            <p>公开国别: {{ item.publicCountryKindName }}  {{ item.applyNumber}}</p>
            <p>申请单位: {{ item.applyUnit }}</p>
            <p>发明人: {{ item.inventor }}</p>
          </div>
        </div>
      </div>
    <!-- <div class="pagination">
      <el-pagination
        @current-change="currentChange"
        :total="total"
        :current-page='currentPage'
        :page-size="pageSize"
        layout="prev, pager, next">
      </el-pagination>
    </div> -->
  </div>
</template>

<script>
import {listPatent} from '@/api/api'

export default {
  data () {
    return {
      type: '',
      total: 1000,
      currentPage: 1,
      pageSize: 99999,
      patentList: []
    }
  },
  created () {
    const type = this.$route.query.type
    console.log(type)
    this.type = type
    this.listPatent()
  },
  methods: {
    // 页码切换时触发
    currentChange (e) {
      console.log(e)
    },
    routerTo (path, row) {
      sessionStorage.detail = JSON.stringify(row)
      this.$router.push({
        path
      })
    },
    listPatent () {
      let data = {
        pageSize: this.pageSize,
        currPage: this.currPage
      }
      listPatent(data).then(res => {
        if (res.code === 200) {
          this.patentList = res.data
        }
      })
    }
  }
}
</script>

<style scoped>
.title {
  letter-spacing: 1px;
  font-size: 28px;
  line-height:2em;
  color: #2f4f4f;
  border-bottom: 3px solid #2f4f4f;
  font-weight: bold;
}

.serch {
  margin-top: 20px;
}
</style>
<style scoped>
.item {
  /* height: 300px; */
   display: flex;
   padding: 10px;
   justify-content: space-between;
   border-bottom: 1px solid #2f4f4f;
   box-sizing: border-box;
}
.item .left{
  flex-grow: 1;
}
.item .right{
  flex-shrink: 0;
}
.item p {
  font-size: 13px;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/view/patents.vue